module.exports = __webpack_public_path__ + "media/images/gift_card-9fe5ddb90b6b8221a5a5cc2edd923ab8.png";